import { makeAutoObservable } from "mobx";
import { IBase64ScreenshotSet, IPropertyAiGrade } from "../services/propertyAiGradeApiService";
import { areScreenshotsSet } from "../utils/aiGradeUtils";

export default class PropertyAiGradeStore {
    isLoadingFor: { [id: string]: boolean } = {};
    isErrorFor: { [id: string]: boolean } = {};
    screenshotsFor: { [id: string]: IBase64ScreenshotSet } = {};
    aiGradesFor: { [id: string]: IPropertyAiGrade } = {};

    constructor() {
        makeAutoObservable(this);
    }

    setIsLoadingFor(id: string, value: boolean) {
        this.isLoadingFor[id] = value;
    }

    getIsLoadingFor(id: string | undefined) {
        return id ? this.isLoadingFor[id] ?? false : false;
    }

    setIsErrorFor(id: string, value: boolean) {
        this.isErrorFor[id] = value;
    }

    getIsErrorFor(id: string | undefined) {
        return id ? this.isErrorFor[id] ?? false : false;
    }

    setAiGradeFor(id: string, aiGrade: IPropertyAiGrade) {
        this.aiGradesFor[id] = aiGrade;
    }

    getAiGradeFor(id: string) {
        return this.aiGradesFor[id];
    }

    setScreenshotForProperty(propertyId: string, key: keyof IBase64ScreenshotSet, base64: string) {
        const current = this.screenshotsFor[propertyId] ?? {};
        this.screenshotsFor[propertyId] = { ...current, [key]: base64 };
    }

    removeScreenshotsForProperty(propertyId: string) {
        this.screenshotsFor[propertyId] = {};
    }

    startLoading(id: string) {
        this.screenshotsFor[id] = {};
        this.isErrorFor[id] = false;
        this.isLoadingFor[id] = true;
    }

    stopLoading(id: string) {
        this.isLoadingFor[id] = false;
    }

    async getScreenshotsForAsync(id: string): Promise<IBase64ScreenshotSet> {
        return new Promise((resolve) => {
            const checkScreenshots = () => {
                const screenshots = this.screenshotsFor[id];
                if (areScreenshotsSet(screenshots)) {
                    resolve(screenshots);
                } else {
                    setTimeout(checkScreenshots, 100);
                }
            };

            checkScreenshots();
        });
    }

    clear() {
        this.aiGradesFor = {};
        this.isLoadingFor = {};
        this.isErrorFor = {};
        this.screenshotsFor = {};
    }
}
